import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import QuotePopUp from "components/popup/quotePopUp/index";
import ContactusMobile from "components/reusableComponents/contactusMobile/ContactusMobile";
import OptimizedImage from "hooks/OptimizedImage";
import loadable from "@loadable/component";
import { reviewsData } from "components/reusableComponents/UsersReviews/reviewsConfig";

export default function Banner() {
  const UsersReviews = loadable(() =>
    import("components/reusableComponents/UsersReviews/UsersReviews")
  );
  const [open, setOpen] = useState(false);
  const [openContactusMobile, setOpenContactusMobile] = useState(false);
  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();

    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };
  const variant = useExperiment("yWZT-4xlS9-M9AZuPD95Xg");
  return (
    <section className="bg-gradient1 md:bg-desktop bg-cover px-2 sm:px-0 pt-5 md:pt-16 pb-8">
      <div className="w-11/12 max-w-7xl mx-auto flex flex-col">
        <h1 className="font-bold text-[36px] font-opensans xs:font-secondary text-midBlue mb-2 w-full break-normal md:hidden">
          Professional Translation Services On a Global Scale
        </h1>
        <h1 className="font-bold text-[32px] lg:text-46 font-opensans xs:font-secondary text-midBlue mb-2 w-full break-normal hidden md:block">
          Professional Translation Services
          <br />
          On a Global Scale
        </h1>
        <p className="font-normal text-17 sm:text-20 leading-8 font-opensans text-midBlue mb-6 w-full md:w-full lg:w-[85%]">
          At Tomedes, we've made it our mission to provide professional
          translation services that leave a lasting impression. Our human
          translators are up for the challenge, whichever translation you need,
          standard document or certified. We speak your language to convey your
          meaning to the world easily.
        </p>
        <div className="inline-flex flex-col md:flex-row justify-start items-start md:items-center gap-7 font-opensans">
          <Link
            to="/quote"
            className="uppercase rounded-full bg-orange hover:bg-newOrange-100 text-white cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-colors duration-300"
          >
            {variant == "1" ? "Order Now" : " Translate Now"}
          </Link>
          <button
            className="hidden md:block uppercase rounded-full bg-white text-[#000101] hover:bg-orange hover:text-white  cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-colors duration-300"
            onClick={() => setOpen(true)}
          >
            Contact Us
          </button>
          <button
            className="md:hidden uppercase rounded-full bg-midBlue hover:bg-[#042E6E] text-white cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-colors duration-300 relative"
            onClick={() => setOpenContactusMobile(true)}
          >
            Contact Us{" "}
            <img
              src="https://tomedes.gumlet.io/assets/icons/arrow-down-circle.svg"
              alt="arrow down"
              className={`${
                openContactusMobile ? "visible" : "invisible"
              } absolute right-6 top-5`}
            />
          </button>
          <ContactusMobile
            open={openContactusMobile}
            setOpen={setOpenContactusMobile}
          />
        </div>
        <ul className="flex lg:flex-row flex-col text-midBlue md:text-white sm:justify-between lg:mx-auto  xl:justify-evenly pt-20 gap-x-10 lg:gap-y-0 gap-y-8 mt-7 pb-[40px] md:pb-24">
          <li className="flex items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/call-center.svg"
              alt=""
              className="w-[53px] lg:w-[40px] h-[53px] lg:h-[40px]"
            />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">
              Available Online 24/7
            </p>
          </li>
          <li className="flex items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/badge.svg"
              alt=""
              className="w-[53px] lg:w-[40px] h-[70px] lg:h-[52px]"
            />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">
              1-Year Guarantee
            </p>
          </li>
          <li className="flex items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/Group.svg"
              alt=""
              className="w-[53px] lg:w-[40px] h-11 lg:h-8"
            />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">
              95,000 Business Customers
            </p>
          </li>
        </ul>
        <UsersReviews reviewsData={reviewsData} containerStyling="pt-5" />
      </div>
      <QuotePopUp open={open} setOpen={setOpen} />
    </section>
  );
}
